// Angular Imports
import { NgModule } from '@angular/core';

// This Module's Components
import { BzTreeComponent } from './tree.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { SharedModule } from 'app/shared/shared.module';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './i18n/', '.json');
  }

@NgModule({
    imports: [
        TranslateModule.forChild({
            loader: {
              provide: TranslateLoader,
              useFactory: HttpLoaderFactory,
              deps: [HttpClient]
            }
        }),
        CommonModule,
        FormsModule,
        SharedModule
    ],
    providers: [
        
    ],
    declarations: [
        BzTreeComponent
    ],
    exports: [
        BzTreeComponent
    ],
    
})
export class BzTreeModule { }
